// You can write more code here

/* START OF COMPILED CODE */

import BaseScene from "../core/scenes/BaseScene";
import TaxiCard from "../prefabs/TaxiCard";
import StatsBar from "../prefabs/StatsBar";
import FitTextToBounds from "../core/components/FitTextToBounds";
import LocaliseText from "../core/components/LocaliseText";
import BtnCarouselArrowRight from "../prefabs/BtnCarouselArrowRight";
import BtnCarouselArrowLeft from "../prefabs/BtnCarouselArrowLeft";
import BtnBack from "../core/prefabs/BtnBack";
import UIPositionContainer from "../core/components/UIPositionContainer";
import BtnAudio from "../core/prefabs/BtnAudio";
import BtnCharacterSelect from "../prefabs/BtnCharacterSelect";
import EarnedPointsTotal from "../prefabs/EarnedPointsTotal";
/* START-USER-IMPORTS */
import { app } from '../core/App';
import { SceneData, TransitionPoint } from '../app-routing';
import { GameDataHandler } from '../GameDataHandler';
import { Character, CharacterName, CharacterNameValues, CharacterData } from '../Character';
import UIButton from '../core/components/UIButton';
/* END-USER-IMPORTS */

export default class CharacterSelect extends BaseScene {

  constructor() {
    super("CharacterSelect");

    /* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // bg
    this.add.image(960, 384, "character-select", "bg-charselect.png");

    // otherTaxiProfile
    const otherTaxiProfile = this.add.container(960, 458);
    otherTaxiProfile.visible = false;

    // otherTaxiProfileImage
    const otherTaxiProfileImage = this.add.image(0, 0, "character-select", "char-spike.png");
    otherTaxiProfile.add(otherTaxiProfileImage);

    // otherDrivers
    const otherDrivers = this.add.container(-960, -458);
    otherTaxiProfile.add(otherDrivers);

    // fig_spike_png_1
    const fig_spike_png_1 = this.add.image(692, 624, "character-select", "fig-spike.png");
    fig_spike_png_1.setOrigin(0.5, 1);
    otherDrivers.add(fig_spike_png_1);

    // fig_tom_png_1
    const fig_tom_png_1 = this.add.image(692, 624, "character-select", "fig-tom.png");
    fig_tom_png_1.setOrigin(0.5, 1);
    otherDrivers.add(fig_tom_png_1);

    // fig_toots_png_1
    const fig_toots_png_1 = this.add.image(692, 624, "character-select", "fig-toots.png");
    fig_toots_png_1.setOrigin(0.5, 1);
    otherDrivers.add(fig_toots_png_1);

    // fig_jerry_png_1
    const fig_jerry_png_1 = this.add.image(739, 455, "character-select", "fig-jerry.png");
    fig_jerry_png_1.setOrigin(0.5, 1);
    otherDrivers.add(fig_jerry_png_1);

    // taxiProfile
    const taxiProfile = this.add.container(960, 458);

    // taxiProfileImage
    const taxiProfileImage = this.add.image(0, 174.5, "character-select", "char-spike.png");
    taxiProfileImage.setOrigin(0.5, 1);
    taxiProfile.add(taxiProfileImage);

    // drivers
    const drivers = this.add.container(-960, -458);
    taxiProfile.add(drivers);

    // fig_spike_png
    const fig_spike_png = this.add.image(692, 624, "character-select", "fig-spike.png");
    fig_spike_png.setOrigin(0.5, 1);
    drivers.add(fig_spike_png);

    // fig_tom_png
    const fig_tom_png = this.add.image(692, 624, "character-select", "fig-tom.png");
    fig_tom_png.setOrigin(0.5, 1);
    drivers.add(fig_tom_png);

    // fig_toots_png
    const fig_toots_png = this.add.image(692, 624, "character-select", "fig-toots.png");
    fig_toots_png.setOrigin(0.5, 1);
    drivers.add(fig_toots_png);

    // fig_jerry_png
    const fig_jerry_png = this.add.image(739, 455, "character-select", "fig-jerry.png");
    fig_jerry_png.setOrigin(0.5, 1);
    drivers.add(fig_jerry_png);

    // taxiCard
    const taxiCard = new TaxiCard(this, 960, 230);
    this.add.existing(taxiCard);

    // statsBarAcceleration
    const statsBarAcceleration = new StatsBar(this, 886, 725);
    this.add.existing(statsBarAcceleration);
    statsBarAcceleration.visible = false;

    // statsBarTopSpeed
    const statsBarTopSpeed = new StatsBar(this, 886, 650);
    this.add.existing(statsBarTopSpeed);
    statsBarTopSpeed.visible = false;

    // accelerationText
    const accelerationText = this.add.text(807, 725, "", {});
    accelerationText.setOrigin(1, 0.5);
    accelerationText.visible = false;
    accelerationText.text = "Acceleration";
    accelerationText.setStyle({ "align": "right", "color": "#ffec00", "fontFamily": "FREDFREDBURGER-BOLD", "fontSize": "42px" });

    // topSpeedText
    const topSpeedText = this.add.text(807, 650, "", {});
    topSpeedText.setOrigin(1, 0.5);
    topSpeedText.visible = false;
    topSpeedText.text = "Top Speed";
    topSpeedText.setStyle({ "align": "right", "color": "#ffec00", "fontFamily": "FREDFREDBURGER-BOLD", "fontSize": "42px", "maxLines":2});

    // btnArrowRight
    const btnArrowRight = new BtnCarouselArrowRight(this, 1460, 478);
    this.add.existing(btnArrowRight);

    // btnArrowLeft
    const btnArrowLeft = new BtnCarouselArrowLeft(this, 460, 478);
    this.add.existing(btnArrowLeft);

    // btnBack
    const btnBack = new BtnBack(this, 84, 84);
    this.add.existing(btnBack);

    // btnAudio
    const btnAudio = new BtnAudio(this, 1836, 84);
    this.add.existing(btnAudio);

    // btnCharacterSelect
    const btnCharacterSelect = new BtnCharacterSelect(this, 960, 695);
    this.add.existing(btnCharacterSelect);

    // earnedPointsTotal
    const earnedPointsTotal = new EarnedPointsTotal(this, 960, 80);
    this.add.existing(earnedPointsTotal);
    earnedPointsTotal.visible = false;

    // accelerationText (components)
    const accelerationTextFitTextToBounds = new FitTextToBounds(accelerationText);
    accelerationTextFitTextToBounds.maxWidth = 320;
    accelerationTextFitTextToBounds.maxHeight = 60;
    accelerationTextFitTextToBounds.minFontSize = 8;
    accelerationTextFitTextToBounds.constrainByWidth = true;
    accelerationTextFitTextToBounds.constrainByHeight = true;
    const accelerationTextLocaliseText = new LocaliseText(accelerationText);
    accelerationTextLocaliseText.copyId = "acceleration";

    // topSpeedText (components)
    const topSpeedTextFitTextToBounds = new FitTextToBounds(topSpeedText);
    topSpeedTextFitTextToBounds.maxWidth = 320;
    topSpeedTextFitTextToBounds.maxHeight = 60;
    topSpeedTextFitTextToBounds.minFontSize = 8;
    topSpeedTextFitTextToBounds.constrainByWidth = true;
    topSpeedTextFitTextToBounds.constrainByHeight = true;
    const topSpeedTextLocaliseText = new LocaliseText(topSpeedText);
    topSpeedTextLocaliseText.copyId = "topSpeed";

    // btnBack (components)
    const btnBackUIPositionContainer = new UIPositionContainer(btnBack);
    btnBackUIPositionContainer.offsetX = 24;
    btnBackUIPositionContainer.offsetY = 24;
    btnBackUIPositionContainer.PinLeft = true;
    btnBackUIPositionContainer.PinTop = true;

    // btnAudio (components)
    const btnAudioUIPositionContainer = new UIPositionContainer(btnAudio);
    btnAudioUIPositionContainer.offsetX = 24;
    btnAudioUIPositionContainer.offsetY = 24;
    btnAudioUIPositionContainer.PinRight = true;
    btnAudioUIPositionContainer.PinTop = true;

    this.otherTaxiProfile = otherTaxiProfile;
    this.otherTaxiProfileImage = otherTaxiProfileImage;
    this.fig_spike_png_1 = fig_spike_png_1;
    this.fig_tom_png_1 = fig_tom_png_1;
    this.fig_toots_png_1 = fig_toots_png_1;
    this.fig_jerry_png_1 = fig_jerry_png_1;
    this.taxiProfile = taxiProfile;
    this.taxiProfileImage = taxiProfileImage;
    this.fig_spike_png = fig_spike_png;
    this.fig_tom_png = fig_tom_png;
    this.fig_toots_png = fig_toots_png;
    this.fig_jerry_png = fig_jerry_png;
    this.taxiCard = taxiCard;
    this.statsBarAcceleration = statsBarAcceleration;
    this.statsBarTopSpeed = statsBarTopSpeed;
    this.accelerationText = accelerationText;
    this.topSpeedText = topSpeedText;
    this.btnArrowRight = btnArrowRight;
    this.btnArrowLeft = btnArrowLeft;
    this.btnBack = btnBack;
    this.btnAudio = btnAudio;
    this.btnCharacterSelect = btnCharacterSelect;

    this.events.emit("scene-awake");
  }

  private otherTaxiProfile!: Phaser.GameObjects.Container;
  private otherTaxiProfileImage!: Phaser.GameObjects.Image;
  private fig_spike_png_1!: Phaser.GameObjects.Image;
  private fig_tom_png_1!: Phaser.GameObjects.Image;
  private fig_toots_png_1!: Phaser.GameObjects.Image;
  private fig_jerry_png_1!: Phaser.GameObjects.Image;
  private taxiProfile!: Phaser.GameObjects.Container;
  private taxiProfileImage!: Phaser.GameObjects.Image;
  private fig_spike_png!: Phaser.GameObjects.Image;
  private fig_tom_png!: Phaser.GameObjects.Image;
  private fig_toots_png!: Phaser.GameObjects.Image;
  private fig_jerry_png!: Phaser.GameObjects.Image;
  private taxiCard!: TaxiCard;
  private statsBarAcceleration!: StatsBar;
  private statsBarTopSpeed!: StatsBar;
  private accelerationText!: Phaser.GameObjects.Text;
  private topSpeedText!: Phaser.GameObjects.Text;
  private btnArrowRight!: BtnCarouselArrowRight;
  private btnArrowLeft!: BtnCarouselArrowLeft;
  private btnBack!: BtnBack;
  private btnAudio!: BtnAudio;
  private btnCharacterSelect!: BtnCharacterSelect;

  /* START-USER-CODE */
  protected sceneData!: SceneData;
  protected characterUpgrades!: Partial<Record<CharacterNameValues, CharacterData>>;
  protected characters!: CharacterNameValues[];
  protected currentCharacter!: CharacterNameValues;
  protected initScaleX!: number;
  protected initScaleY!: number;
  protected prevCarouselIndex!: number;
  protected carouselIndex!: number;

  protected jerryY:number = 0;
  protected tomY:number = 0;
  protected tootsY:number = 0;
  protected spikeY:number = 0;

  public init(data: SceneData): void {
    this.sceneData = data;

    super.init(data);
  }

  public create() {
    super.create();
    this.editorCreate();

    this.btnBack.once(UIButton.events.clicked, this.back, this);

    this.prevCarouselIndex = 0;
    this.carouselIndex = 0;

    this.characterUpgrades = this.game.registry.get(GameDataHandler.keys.CharacterData);
    this.characters = Object.values(CharacterName) as CharacterNameValues[];

    if (this.sceneData.runSettings && this.sceneData.runSettings.selectedCharacter) {
      let index = this.characters.indexOf(this.sceneData.runSettings.selectedCharacter);
      this.prevCarouselIndex = index;
      this.carouselIndex = index;
    }

    this.getNextCharacter();
    this.displayCurrentCharacter();
    this.taxiProfileImage.setFrame(Character.taxiProfileLookup[this.currentCharacter]);
    this.updateToCharacter(this.currentCharacter);

    // this.btnUpgradeTopSpeed.on(UIButton.events.clicked, this.tryPurchaseTopSpeedUpgrade, this);
    // this.btnUpgradeAcceleration.on(UIButton.events.clicked, this.tryPurchaseAccelerationUpgrade, this);

    this.btnArrowLeft.on(UIButton.events.clicked, this.changeLeft, this);
    this.btnArrowRight.on(UIButton.events.clicked, this.changeRight, this);
    this.btnCharacterSelect.once(UIButton.events.clicked, this.onCharacterSelected, this);

    this.jerryY = 456;//this.fig_jerry_png.y;
    this.tomY = this.fig_tom_png.y;
    this.spikeY = this.fig_spike_png.y;
    this.tootsY = this.fig_toots_png.y;

    // this.bindInput();
  }

  public back() {
    app.gotoNextScene(this, TransitionPoint.CharacterSelectBack);
  }

  protected bindInput() {
    this.initScaleX = this.taxiProfile.scaleX;
    this.initScaleY = this.taxiProfile.scaleY;
    this.taxiProfile.setInteractive();

    this.taxiProfile.on(Phaser.Input.Events.POINTER_DOWN, () => {
      this.add.tween({
        targets: this.taxiProfile,
        scaleX: this.initScaleX * 0.8,
        scaleY: this.initScaleY * 0.8,
        duration: 80
        // yoyo: true,
      });
    });

    this.taxiProfile.on(Phaser.Input.Events.POINTER_UP, () => {
      this.add.tween({
        targets: this.taxiProfile,
        scaleX: this.initScaleX,
        scaleY: this.initScaleY,
        duration: 80,
        ease: Phaser.Math.Easing.Cubic.InOut,
        // yoyo: true,
        onComplete: () => {
          this.onCharacterSelected();
        }
      });
    });

    this.taxiProfile.on(Phaser.Input.Events.POINTER_OUT, () => {
      this.add.tween({
        targets: this.taxiProfile,
        scaleX: this.initScaleX,
        scaleY: this.initScaleY,
        duration: 80,
        ease: Phaser.Math.Easing.Cubic.InOut
        // yoyo: true,
        // onComplete: () => {}
      });
    });
  }

  protected getNextCharacter() {
    this.currentCharacter = this.characters[((this.carouselIndex % this.characters.length) + this.characters.length) % this.characters.length];
    return this.currentCharacter;
  }

  protected updateToCharacter(character: CharacterNameValues) {
    this.taxiCard.changeOwner(character);
    this.displayNextCharacter(character);
    this.otherTaxiProfileImage.setFrame(Character.taxiProfileLookup[character]);

    let numTopSpeedUpgrades = this.characterUpgrades[character]?.topSpeedUpgrades ?? 0;
    let numAccelerationUpgrades = this.characterUpgrades[character]?.accelerationUpgrades ?? 0;

    this.statsBarTopSpeed.setFilledSegments(numTopSpeedUpgrades);
    this.statsBarAcceleration.setFilledSegments(numAccelerationUpgrades);

    // if (numTopSpeedUpgrades < 5) {
    //   this.btnUpgradeTopSpeed.setUpgradeCost(Character.topSpeedUpgradeCosts[numTopSpeedUpgrades]);
    //   this.btnUpgradeTopSpeed.setVisible(true);
    // } else {
    //   this.btnUpgradeTopSpeed.setVisible(false);
    // }

    // if (numAccelerationUpgrades < 5) {
    //   this.btnUpgradeAcceleration.setUpgradeCost(Character.accelerationUpgradeCosts[numAccelerationUpgrades]);
    //   this.btnUpgradeAcceleration.setVisible(true);
    // } else {
    //   this.btnUpgradeAcceleration.setVisible(false);
    // }
  }

  protected changeLeft() {
    this.prevCarouselIndex = this.carouselIndex;
    this.carouselIndex--;

    this.tweens.killTweensOf(this.taxiProfile);
    this.tweens.killTweensOf(this.otherTaxiProfile);

    this.taxiProfile.x = 960;
    this.taxiProfile.alpha = 1;
    this.taxiProfile.setVisible(true);
    this.add.tween({
      targets: this.taxiProfile,
      alpha: 0,
      x: `-=300`,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.Out
    });
    this.displayNextCharacter(this.currentCharacter);
    this.otherTaxiProfile.x = 960 + 300;
    this.otherTaxiProfile.alpha = 0;
    this.otherTaxiProfile.setVisible(true);
    this.add.tween({
      targets: this.otherTaxiProfile,
      alpha: 1,
      x: `-=300`,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: () => {
        this.displayCurrentCharacter();
        this.taxiProfileImage.setFrame(Character.taxiProfileLookup[this.currentCharacter]);
        this.taxiProfile.x = 960;
        this.taxiProfile.alpha = 1;

        this.otherTaxiProfile.alpha = 0;
        this.otherTaxiProfile.setVisible(false);
      }
    });

    this.getNextCharacter();
    this.updateToCharacter(this.currentCharacter);
  }

  protected changeRight() {
    this.prevCarouselIndex = this.carouselIndex;
    this.carouselIndex++;

    this.tweens.killTweensOf(this.taxiProfile);
    this.tweens.killTweensOf(this.otherTaxiProfile);

    this.taxiProfile.x = 960;
    this.taxiProfile.alpha = 1;
    this.taxiProfile.setVisible(true);
    this.add.tween({
      targets: this.taxiProfile,
      alpha: 0,
      x: `+=300`,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.Out
    });
    this.displayNextCharacter(this.currentCharacter);
    this.otherTaxiProfile.x = 960 - 300;
    this.otherTaxiProfile.alpha = 0;
    this.otherTaxiProfile.setVisible(true);
    this.add.tween({
      targets: this.otherTaxiProfile,
      alpha: 1,
      x: `+=300`,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: () => {
        this.displayCurrentCharacter();
        this.taxiProfileImage.setFrame(Character.taxiProfileLookup[this.currentCharacter]);
        this.taxiProfile.x = 960;
        this.taxiProfile.alpha = 1;

        this.otherTaxiProfile.alpha = 0;
        this.otherTaxiProfile.setVisible(false);
      }
    });

    this.getNextCharacter();
    this.updateToCharacter(this.currentCharacter);
  }

  protected displayCurrentCharacter(){
    this.killTaxiTweens();

    this.add.tween({
      targets: this.taxiProfileImage,
      scaleX: 1.0,
      scaleY: 1.01,
      duration: 200,
      ease: Phaser.Math.Easing.Cubic.InOut,
      yoyo: true,
      repeat: -1
    });

      this.fig_jerry_png.setVisible(false);
      this.fig_toots_png.setVisible(false);
      this.fig_tom_png.setVisible(false);
      this.fig_spike_png.setVisible(false);

      if(this.currentCharacter == CharacterName.Tom){
        this.fig_tom_png.setVisible(true);
        this.add.tween({
          targets: this.fig_tom_png,
          scaleX: 1.0,
          scaleY: 1.02,
          duration: 900,
          ease: Phaser.Math.Easing.Cubic.InOut,
          yoyo: true,
          repeat: -1
        });
      }
      else if(this.currentCharacter == CharacterName.Jerry){
        this.fig_jerry_png.setVisible(true);
        this.add.tween({
          targets: this.fig_jerry_png,
          y: this.jerryY-2,
          duration: 200,
          ease: Phaser.Math.Easing.Cubic.InOut,
          yoyo: true,
          repeat: -1
        });
        this.add.tween({
          targets: this.fig_jerry_png,
          scaleX: 1.0,
          scaleY: 1.05,
          duration: 500,
          ease: Phaser.Math.Easing.Cubic.InOut,
          yoyo: true,
          repeat: -1
        });
      }
      else if(this.currentCharacter == CharacterName.Toots){
        this.fig_toots_png.setVisible(true);
        this.add.tween({
          targets: this.fig_toots_png,
          scaleX: 1.0,
          scaleY: 1.01,
          duration: 900,
          ease: Phaser.Math.Easing.Cubic.InOut,
          yoyo: true,
          repeat: -1
        });
      }
      else if(this.currentCharacter == CharacterName.Spike){
        this.fig_spike_png.setVisible(true);
        this.add.tween({
          targets: this.fig_spike_png,
          scaleX: 1.0,
          scaleY: 1.02,
          duration: 900,
          ease: Phaser.Math.Easing.Cubic.InOut,
          yoyo: true,
          repeat: -1
        });
      }


  }

  protected killTaxiTweens(){
    this.tweens.killTweensOf(this.taxiProfileImage);
    this.tweens.killTweensOf(this.fig_jerry_png);
    this.tweens.killTweensOf(this.fig_toots_png);
    this.tweens.killTweensOf(this.fig_tom_png);
    this.tweens.killTweensOf(this.fig_spike_png);

    this.taxiProfileImage.scaleY=1;
    this.fig_jerry_png.y = this.jerryY;

    this.fig_jerry_png.scaleY = 1;
    this.fig_tom_png.scaleY = 1;
    this.fig_spike_png.scaleY = 1;
    this.fig_toots_png.scaleY = 1;
  }

  protected displayNextCharacter(character: CharacterNameValues){
    this.killTaxiTweens();

    this.fig_jerry_png_1.setVisible(false);
    this.fig_toots_png_1.setVisible(false);
    this.fig_tom_png_1.setVisible(false);
    this.fig_spike_png_1.setVisible(false);

    if(character == CharacterName.Tom){
      this.fig_tom_png_1.setVisible(true);
    }
    else if(character == CharacterName.Jerry){
      this.fig_jerry_png_1.setVisible(true);
    }
    else if(character == CharacterName.Toots){
      this.fig_toots_png_1.setVisible(true);
    }
    else if(character == CharacterName.Spike){
      this.fig_spike_png_1.setVisible(true);
    }
}

  protected tryPurchaseTopSpeedUpgrade() {
    let numUpgrades = this.characterUpgrades[this.currentCharacter]?.topSpeedUpgrades ?? 0;
    let costToUpgrade = Character.topSpeedUpgradeCosts[numUpgrades];

    if (GameDataHandler.canPurchase(this, costToUpgrade) && numUpgrades < Character.maxTopSpeedUpgrades) {
      app.audioHandler.playSound(this, 'SndLevelUnlock', 'sfx');
      GameDataHandler.spendEarnedPoints(this, costToUpgrade);
      GameDataHandler.addTopSpeedUpgrade(this, this.currentCharacter);

      this.characterUpgrades = this.game.registry.get(GameDataHandler.keys.CharacterData);
      this.statsBarTopSpeed.setFilledSegments(numUpgrades + 1);

      // if (numUpgrades + 1 < 5) this.btnUpgradeTopSpeed.setUpgradeCost(Character.topSpeedUpgradeCosts[numUpgrades + 1]);
      // else this.btnUpgradeTopSpeed.setVisible(false);
    } else {
      // Purchase failed.
      app.audioHandler.playSound(this, 'SndLevelLocked', 'sfx');
    }
  }

  protected tryPurchaseAccelerationUpgrade() {
    let numUpgrades = this.characterUpgrades[this.currentCharacter]?.accelerationUpgrades ?? 0;
    let costToUpgrade = Character.accelerationUpgradeCosts[numUpgrades];

    if (GameDataHandler.canPurchase(this, costToUpgrade) && numUpgrades < Character.maxAccelerationUpgrades) {
      app.audioHandler.playSound(this, 'SndLevelUnlock', 'sfx');
      GameDataHandler.spendEarnedPoints(this, costToUpgrade);
      GameDataHandler.addAccelerationUpgrade(this, this.currentCharacter);

      this.characterUpgrades = this.game.registry.get(GameDataHandler.keys.CharacterData);
      this.statsBarAcceleration.setFilledSegments(numUpgrades + 1);

      // if (numUpgrades + 1 < 5) this.btnUpgradeAcceleration.setUpgradeCost(Character.accelerationUpgradeCosts[numUpgrades + 1]);
      // else this.btnUpgradeAcceleration.setVisible(false);
    } else {
      // Purchase failed.
      app.audioHandler.playSound(this, 'SndLevelLocked', 'sfx');
    }
  }

  protected onCharacterSelected() {
    if (!this.sceneData.runSettings) this.sceneData.runSettings = {};
    this.sceneData.runSettings.selectedCharacter = this.currentCharacter;

    if(this.currentCharacter == CharacterName.Tom){
      app.audioHandler.playSound(this, 'SndSelectTom', 'sfx');
    }
    else if(this.currentCharacter == CharacterName.Jerry){
      app.audioHandler.playSound(this, 'SndSelectJerry', 'sfx');
    }
    else if(this.currentCharacter == CharacterName.Toots){
      app.audioHandler.playSound(this, 'SndSelectToodles', 'sfx');
    }
    else if(this.currentCharacter == CharacterName.Spike){
      app.audioHandler.playSound(this, 'SndSelectSpike', 'sfx');
    }


    app.gotoNextScene(this, TransitionPoint.CharacterSelectEnd, this.sceneData);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
